import Axios from 'axios';
import React, { FormEvent, useEffect, useState } from 'react';
import { Button, Overlay, OverlayTrigger, Popover } from 'react-bootstrap';
import AxiosConfig from 'src/utilities/AxiosConfig';
import './invoice.css';
import { BillingGroupType, InvoiceType } from './types';
import { Formik, Form, useField } from 'formik';
import * as Yup from 'yup';
import './EditBillingGroup.css'
import ReactQuill from 'react-quill-v2.0';
import { Checkbox } from '@fluentui/react';


interface IProps {
    showEditBillingGroup: boolean;
    setShowEditBillingGroup: Function;
    billingGroup: BillingGroupType;
    invoices: InvoiceType[];
    setInvoices: Function;
    contactDetailsOnly: boolean;
    setContactDetailsOnly: Function;
    getActiveBillingGroups: Function;
    setActiveBillingGroups: Function;
    activeBillingGroups: BillingGroupType[];
}

const EditBillingGroup = (props: IProps) => {
    let toolbar = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link'],
            [{ 'align': [] }],
            ['clean']
        ]
    }
    let quillFormats = ["font", "color", "header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link"]
    const { setShowEditBillingGroup, showEditBillingGroup, billingGroup, getActiveBillingGroups, contactDetailsOnly, setContactDetailsOnly, setActiveBillingGroups, activeBillingGroups } = props;
    //r-18-lint-cm
    //eslint-disable-next-line
    const [editedGroup, setEditedGroup] = useState({ ...billingGroup } as BillingGroupType);
    let config = AxiosConfig.configValue("min");
    //console.log("Billing Group ", billingGroup)

    // !! Now handled by Formik
    // const handleInputChange = (e: any) => {
    //     //console.log("Targets ", e.target.name, e.target.value)
    //     setEditedGroup({ ...editedGroup, [e.target.name]: e.target.value })
    //     //console.log("Edited Group Item", editedGroup);
    // }

    //********************************** Items for updating Billing group ***************************** */
    const updateBillingGroup = (entry: any) => {
        let entryToEdit = { ...entry };
        //console.log("Entry to edit", entryToEdit)
        Axios.post(`${process.env.REACT_APP_API_URL}/api/ip/addOrUpdateBillingGroup`, entryToEdit, config)
            .then((res) => {
                //console.log("Data from update", res.data)
                let billingGroupCopy = [...activeBillingGroups];
                let indexToUpdate = billingGroupCopy.findIndex((actBillingGroup) => actBillingGroup.BillingGroupID === res.data.BillingGroupID);
                billingGroupCopy[indexToUpdate] = res.data;
                //console.log("Billing Group Copy and index ", billingGroupCopy, indexToUpdate, billingGroupCopy[indexToUpdate])
                setActiveBillingGroups(billingGroupCopy);
                //cgm even though I added the edited group to the front end side of the 
                // array I still pull it again so that the data is accurately reflective of the db
                getActiveBillingGroups();
            })
            .catch((err) => {

            })
            .finally(() => {
                setShowEditBillingGroup(false);
            })
    }

    const generateBillingGroupObjectFromValues = (values: any) => {
        let editableBillingGroup = { ...billingGroup }
        for (let [key, value] of Object.entries(values)) {
            editableBillingGroup = { ...editableBillingGroup, [key]: value }
        }
        return editableBillingGroup;
    }

    const billingGroupFormInitialValues = {
        BillingGroupName: billingGroup.BillingGroupName,
        InvoicingGroup: billingGroup.InvoicingGroup,
        InvoiceStorageLocation: billingGroup.InvoiceStorageLocation,
        ContactName: billingGroup.ContactName,
        ContactPhone: billingGroup.ContactPhone,
        MailingName: billingGroup.MailingName,
        AgingWarningAdjustment: billingGroup.AgingWarningAdjustment,
        MailingAddress: billingGroup.MailingAddress,
        MailingCity: billingGroup.MailingCity,
        MailingState: billingGroup.MailingState || "",
        MailingZip: billingGroup.MailingZip || "",
        EmailTo: billingGroup.EmailTo,
        EmailCC: billingGroup.EmailCC || "",
        EmailBCC: billingGroup.EmailBCC || "",
        EmailSubject: billingGroup.EmailSubject,
        EmailMessage: billingGroup.EmailMessage,
        EmailSignature: billingGroup.EmailSignature,
        SpecialInstructions: billingGroup.SpecialInstructions
    }

    const billingGroupFormValidationSchema =
        Yup.object({
            BillingGroupName: Yup.string().required('Required'),
            InvoicingGroup: Yup.string().required('Required').nullable(),
            InvoiceStorageLocation: Yup.string().required('Required').nullable(),
            ContactName: Yup.string().required('Required').nullable(),
            ContactPhone: Yup.string().required('Required').nullable(),
            MailingName: Yup.string().required('Required').nullable(),
            AgingWarningAdjustment: Yup.number().nullable(),
            MailingAddress: Yup.string().required('Required').nullable(),
            MailingCity: Yup.string().required('Required').nullable(),
            MailingState: Yup.string().max(2, '2 letter state code').required().nullable(),
            MailingZip: Yup.string().nullable(),
            EmailTo: Yup.array()
            .transform(function(value, originalValue) {
              if (this.isType(value) && value !== null) {
                return value;
              }
              return originalValue ? originalValue.split(/[\s;]+/) : [];
            })
            .of(Yup.string().email(({ value }) => `${value} is not a valid email`)),
            EmailCC: Yup.array()
            .transform(function(value, originalValue) {
              if (this.isType(value) && value !== null) {
                return value;
              }
              return originalValue ? originalValue.split(/[\s;]+/) : [];
            })
            .of(Yup.string().email(({ value }) => `${value} is not a valid email`)).nullable(),
            EmailBCC: Yup.array()
            .transform(function(value, originalValue) {
              if (this.isType(value) && value !== null) {
                return value;
              }
              return originalValue ? originalValue.split(/[\s;]+/) : [];
            })
            .of(Yup.string().email(({ value }) => `${value} is not a valid email`)).nullable(),
            EmailSubject: Yup.string().min(5, 'Subject must be 5 characters or more').required('Required').nullable(),
            EmailMessage: Yup.string().min(5, 'Message must be 5 characters or more').required('Required').nullable(),
            EmailSignature: Yup.string().required('Required').nullable(),
            SpecialInstructions: Yup.string().nullable(),
            isPDF: Yup.bool(),
            isXLSX: Yup.bool()
        })

    const closeContactDetails = () => {
        setContactDetailsOnly(false);
        setShowEditBillingGroup(false);
    }

    //@ts-ignore
    const MyTextInput = ({ label, ...props }) => {
        // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
        // which we can spread on <input> and alse replace ErrorMessage entirely.
        //@ts-ignore
        const [field, meta] = useField(props);
        return (
            <>
                <label className='standard-label' htmlFor={props.id || props.name}>{label}</label>
                <input className="text-input" {...field} {...props} />
                {
                    label === "Email Subject"?
                    <OverlayTrigger 
                        placement='left'
                        overlay={(
                            <Popover id='edit-billing-group-email-info'>
                                <Popover.Title as={"h4"}>
                                    <span>Subject Options</span>
                                </Popover.Title>
                                <Popover.Content>
                                    <h5>Variables</h5>
                                    <p>
                                        Varialbes are a collection of capital characters contained in the characters 
                                        [ ] that the system will recognize as an input 
                                        and replace the text with a value assosiated with the recognized variable. 
                                        Variables are listed below in this tooltip
                                    </p>
                                    <h6>{"[INVOICE#]"}</h6>
                                    <p>This variable will tell the system to put the Invoice Number in that spot in the subject</p>
                                    <h6>{"[WEEKENDING]"}</h6>
                                    <p>This variable will tell the system to put the Week Ending where the variable is</p>
                                </Popover.Content>
                            </Popover>
                        )}
                    >
                        <span className='material-icons' style={{lineHeight: 2, color: "#17A2B8", marginLeft:-5}}>info</span>
                    </OverlayTrigger>
                    :label === "Email To"?
                    <OverlayTrigger 
                        placement='left'
                        overlay={(
                            <Popover id='edit-billing-group-email-info'>
                                <Popover.Title as={"h4"}>
                                    <span>Email Options</span>
                                </Popover.Title>
                                <Popover.Content>
                                    <h5>Multiple Emails:</h5>
                                    <span>
                                        For multiple emails separate the addresses with a semicolon
                                        <p>Example:<br/> abc@example.com; def@example.com</p>
                                    </span>
                                </Popover.Content>
                            </Popover>
                        )}
                    >
                        <span className='material-icons' style={{lineHeight: 2, color: "#17A2B8", marginLeft:-5}}>info</span>
                    </OverlayTrigger>
                    :null
                }
                {meta.touched && meta.error ? (
                    <div className="error">{meta.error}</div>
                ) : null}
            </>
        );
    };

    //@ts-ignore
    const FormikTextArea = ({ label, ...props }) => {
        //@ts-ignore
        const [field, meta] = useField(props);
        return (
            <>
                <label className='standard-label' htmlFor={props.id || props.name}>{label}</label>
                <textarea className='text-area' {...field} {...props} />
                {meta.touched && meta.error ? (
                    <div className="error">{meta.error}</div>
                ) : null}
            </>
        )
    }
    const FormikBool = (props:any) => {
        const [field, meta] = useField(props);
        field.name = "checkbox"
        const onChange = (e:any)=>{
            let newEvent = e
            newEvent.target.value = e.target.checked
            return field.onChange(newEvent)
        }
        return (
            <>
                <label className='standard-label' htmlFor={props.id || props.name}>{props.label}</label>
                <Checkbox 
                    className='text-input' {...field} {...props}  label={null}
                    defaultChecked = {props.placeholder}
                    onChange={(e) => e!== undefined ? onChange(e): null}
                />
                {meta.touched && meta.error ? (
                    <div className="error">{meta.error}</div>
                ) : null}
            </>
        )
    }
    const FormikRichText = (props: any) => {
        //@ts-ignore
        const [field, meta] = useField(props);
        return (
            <>
                <label className='standard-label' htmlFor={props.id || props.name}>{props.label}</label>
                <ReactQuill 
                    className='text-area'
                    {...field}
                    {...props}
                    formats={[...quillFormats, "color"]}
                    modules={props.toolbar}
                    onChange={field.onChange(field.name)}
                />
                {meta.touched && meta.error ? (
                    <div className="error">{meta.error}</div>
                ) : null}
            </>
        )
    }
    //console.log("BILLING Group", billingGroup)

    return (
        <div id="EditBillingGroup" >
            <h2 className='mb-2 EditBillingGroupTitle' >Edit Billing Group</h2>
            <Formik
                initialValues={billingGroupFormInitialValues}
                validationSchema={billingGroupFormValidationSchema}
                onSubmit={(values) => {
                    let objectForUpdate = generateBillingGroupObjectFromValues(values);
                    updateBillingGroup(objectForUpdate);
                }}
            >
                <Form className='EditBillingGroupForm'>
                    <div className='billing-group-div d-flex flex-row justify-content-between'>
                        <div className=' d-flex flex-row ' >
                            <MyTextInput
                                label="Billing Group Name"
                                readOnly
                                disabled={contactDetailsOnly}
                                name="BillingGroupName"
                                type="text"
                                placeholder={billingGroup.BillingGroupName}
                                className="billing-group-inputs"
                            />
                        </div>
                        <div className=' d-flex flex-row invoicing-group-div' >
                            <MyTextInput
                                label="Invoicing Group"
                                name="InvoicingGroup"
                                type="text"
                                placeholder={billingGroup.InvoicingGroup || ""}
                                readOnly={contactDetailsOnly}
                                disabled={contactDetailsOnly}
                                className="billing-group-inputs"
                            />
                        </div>
                    </div>
                    <div className='d-flex flex-row'>
                        <MyTextInput
                            label="Invoice Location"
                            name="InvoiceStorageLocation"
                            type="text"
                            placeholder={billingGroup.InvoiceStorageLocation || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs full-width-input"
                        />
                    </div>
                    <div className='d-flex flex-row '>
                        <MyTextInput
                            label="Contact Name"
                            name="ContactName"
                            disabled={contactDetailsOnly}
                            type="text"
                            placeholder={billingGroup.ContactName || ""}
                            readOnly={contactDetailsOnly}
                            className="billing-group-inputs"
                        />
                        <MyTextInput
                            label="Contact Phone"
                            name="ContactPhone"
                            type="text"
                            placeholder={billingGroup.ContactPhone || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs"
                        />
                    </div>
                    <div className='mailing-aging-div d-flex flex-row '>
                        <MyTextInput
                            label="Mailing Name"
                            name="MailingName"
                            type="text"
                            placeholder={billingGroup.MailingName || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs"
                        />
                        <MyTextInput
                            label="Aging Warning Adjustment"
                            name="AgingWarningAdjustment"
                            type="text"
                            placeholder={billingGroup.AgingWarningAdjustment || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs"
                        />
                    </div>
                    <div className='standard-form-width-div d-flex flex-row '>
                        <MyTextInput
                            label="Mailing Address"
                            name="MailingAddress"
                            type="text"
                            placeholder={billingGroup.MailingAddress || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs"
                        />
                    </div>
                    <div className='standard-form-width-div d-flex flex-row '>
                        <MyTextInput
                            label="Mailing City"
                            name="MailingCity"
                            type="text"
                            placeholder={billingGroup.MailingCity || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs"
                        />
                        <MyTextInput
                            label="Mailing State"
                            name="MailingState"
                            type="text"
                            placeholder={billingGroup.MailingState || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs"
                        />
                        <MyTextInput
                            label="Mailing Zip"
                            name="MailingZip"
                            type="text"
                            placeholder={billingGroup.MailingZip || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs"
                        />
                    </div>
                    <div className='standard-form-width-div d-flex flex-row'>
                        <FormikBool                             
                            label="PDF format"
                            name="isPDF"
                            type="bool"
                            placeholder={billingGroup.isPDF}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs-bool"
                        />
                        <FormikBool                             
                            label="XLSX Format"
                            name="isXLSX"
                            type="boolean"
                            placeholder={billingGroup.isXLSX}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs-bool"
                        />
                    </div>
                    <div className='standard-form-width-div d-flex flex-row '>
                        <MyTextInput
                            label="Email To"
                            name="EmailTo"
                            type="text"
                            placeholder={billingGroup.EmailTo || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs full-width-input"
                        />
                    </div>
                    <div className='standard-form-width-div d-flex flex-row '>
                        <MyTextInput
                            label="Email CC"
                            name="EmailCC"
                            type="text"
                            placeholder={billingGroup.EmailCC || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs full-width-input"
                        />
                    </div>
                    <div className='standard-form-width-div d-flex flex-row '>
                        <MyTextInput
                            label="Email BCC"
                            name="EmailBCC"
                            type="text"
                            placeholder={billingGroup.EmailBCC || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs full-width-input"
                        />
                    </div>
                    <div className='standard-form-width-div d-flex flex-row '>
                        <MyTextInput
                            label="Email Subject"
                            name="EmailSubject"
                            type="text"
                            placeholder={billingGroup.EmailSubject || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs full-width-input"
                        />
                    </div>
                    <div className='IPRichTextheight d-flex flex-row '>
                        {/* <MyTextInput
                            label="Message"
                            name="EmailMessage"
                            type="text"
                            placeholder={billingGroup.EmailMessage || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="billing-group-inputs full-width-input text-area"
                        /> */}
                        <FormikRichText
                            label="Message"
                            name="EmailMessage"
                            type="text"
                            defaultValue={billingGroup.EmailMessage || ""}
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            className="full-width-input IPRichText"
                            toolbar={toolbar}
                        />
                    </div>
                    <div className='IPRichTextheight d-flex flex-row '>
                        {/* <MyTextInput
                            label="Email Signature"
                            name="EmailSignature"
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            type="text"
                            placeholder={billingGroup.EmailSignature || ""}
                            className="billing-group-inputs full-width-input text-area"
                        /> */}
                        <FormikRichText
                            label="Email Signature"
                            name="EmailSignature"
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            type="text"
                            defaultValue={billingGroup.EmailSignature || ""}
                            className="full-width-input IPRichText"
                            toolbar={{toolbar: [...toolbar.toolbar, [{ 'color': [] }], [{ 'font': [] }]]}}
                        />
                    </div>
                    <div className='standard-form-width-div d-flex flex-row '>
                        {/* <MyTextInput
                            label="Special Instructions"
                            name="SpecialInstructions"
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            placeholder={billingGroup.SpecialInstructions}
                            type="text"
                            className="billing-group-inputs full-width-input text-area"
                        /> */}
                        <FormikTextArea
                            label="Special Instructions"
                            name="SpecialInstructions"
                            readOnly={contactDetailsOnly}
                            disabled={contactDetailsOnly}
                            placeholder={billingGroup.SpecialInstructions}
                            type="textarea"
                            className="billing-group-inputs full-width-input text-area"
                        />
                    </div>
                    <div className='d-flex flex-row-reverse'>
                        {
                            contactDetailsOnly ?
                                <Button onClick={() => closeContactDetails()} className="btn btn-primary ml-2 mr-5" >Close</Button>
                                :
                                <>
                                    <button type='submit' className="btn btn-primary ml-2 mr-5" >Save</button>
                                    {/* <Button onClick={() => updateBillingGroup()} className="btn btn-primary ml-2 mr-5" >Save</Button> */}
                                    <Button onClick={() => setShowEditBillingGroup(!showEditBillingGroup)} className="btn btn-danger" >Cancel</Button>
                                </>
                        }

                    </div>
                </Form>
            </Formik>
        </div>
    )
}
export default EditBillingGroup;
